import axios from 'axios'

const URL_PATH = '/ata-registro-preco/api/public'

class AnuenciaAdesaoApiClient {
	async buscarDadosCabecalho(idControleAnuencia) {
		return await axios.get(`${URL_PATH}/adesao/anuencia/${idControleAnuencia}/cabecalho`)
	}
	async finalizarAnuencia(objRecusaAdesao) {
		return await axios.put(
			`${URL_PATH}/adesao/anuencia/${objRecusaAdesao.idEmailAdesaoFornec}/itens/finalizar`,
			objRecusaAdesao,
		)
	}
}

export default new AnuenciaAdesaoApiClient()
